import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { Link } from 'atoms/Link/Link';
import { Span } from 'atoms/Typography';
import { gtmPushShopNavigation } from 'modules/gtm/modules/sections/navigation/navigation';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useMediaQuery } from 'modules/mui/hooks';
import { useCart } from 'modules/shop/cart/hooks';
import { AppRoutes } from 'modules/shop/routes';
import styles from '../styles.module.css';

export const CartIcon: FC<{ onClick: () => void; className?: string }> = ({
  onClick,
  className,
}) => {
  const t = useTranslations();
  const { cart } = useCart();
  const count = cart?.items?.length;

  const { isTablet } = useMediaQuery();

  const handleClick = () => {
    onClick();
    gtmPushShopNavigation(t('header.gtmNavigationLabels.cartIcon'));
  };

  if (isTablet) {
    return (
      <div className={styles.icon} onClick={handleClick}>
        <Span className={styles.counter}>{count}</Span>
        <Icon type={IconType.cart} className={className} />
      </div>
    );
  }

  return (
    <Link href={AppRoutes.CART} className={styles.icon} onClick={handleClick}>
      <Span className={styles.counter}>{count}</Span>
      <Icon type={IconType.cart} className={className} />
    </Link>
  );
};
